export default function Statistiche() {
  return (
    <div style={{ padding: "40px 32px", fontFamily: "'DM Sans', sans-serif" }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1E293B", marginBottom: 8, letterSpacing: "-0.02em" }}>
        📉 Statistiche
      </h1>
      <p style={{ fontSize: 14, color: "#64748B" }}>
        Sezione attualmente in fase di sviluppo.
      </p>
      <div style={{
        marginTop: 40, padding: "60px 20px", textAlign: "center",
        border: "2px dashed #E2E8F0", borderRadius: 12, color: "#94A3B8"
      }}>
        <div style={{ fontSize: 40, marginBottom: 12, opacity: 0.3 }}>🚧</div>
        <div style={{ fontSize: 14, fontWeight: 600 }}>In costruzione</div>
        <div style={{ fontSize: 12, marginTop: 4 }}>Questa sezione sarà disponibile prossimamente</div>
      </div>
    </div>
  );
}
